import commonService from '@/service/commonService'

export default {
  data () {
    return {
      imageCodeSrc: '',
      show: true,
      count: '',
      showCount: '发送验证码',
      timer: null
    }
  },
  mounted () {
    this.refreshImageCode && this.refreshImageCode()
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    getSmsForm () {
      return this.devredisterForm || this.resetpwdForm || {}
    },
    getSmsMessageOptions () {
      return {}
    },
    showSmsError (message) {
      const options = this.getSmsMessageOptions()
      if (options.customClass) {
        this.$message.error({
          message,
          customClass: options.customClass
        })
      } else {
        this.$message.error(message)
      }
    },
    showSmsSuccess (message) {
      const options = this.getSmsMessageOptions()
      if (options.customClass) {
        this.$message.success({
          message,
          customClass: options.customClass
        })
      } else {
        this.$message.success(message)
      }
    },
    async refreshImageCode () {
      try {
        const form = this.getSmsForm()
        const deviceId = form.mobile || String(Date.now())
        this.$cookie.set('deviceId', deviceId)
        const res = await commonService.getImageCode()
        this.imageCodeSrc = res ? `data:image/jpeg;base64,${res}` : ''
        this.$set(form, 'imageCode', '')
      } catch (e) {
        this.showSmsError(e && e.msg || '图形验证码获取失败')
      }
    },
    startSmsCountDown () {
      const TIME_COUNT = 60
      if (this.timer) {
        return
      }
      this.count = TIME_COUNT
      this.showCount = '发送验证码(' + this.count + ')'
      this.show = false
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--
          this.showCount = '发送验证码(' + this.count + ')'
        } else {
          this.show = true
          this.showCount = '发送验证码'
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    async sendSmsCodeWithImage () {
      const form = this.getSmsForm()
      if (!form.mobile || form.mobile.length !== 11) {
        this.showSmsError('请填写有效的手机号码')
        return
      }
      if (!form.imageCode) {
        this.showSmsError('请输入图形验证码')
        return
      }
      try {
        this.$cookie.set('deviceId', form.mobile)
        await commonService.senCode(form.mobile, form.imageCode)
        this.startSmsCountDown()
        this.showSmsSuccess('验证码已发送')
      } catch (e) {
        this.refreshImageCode()
        this.showSmsError(e && e.msg)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/smsImageCodeMixin.js